import { useMemo } from "react";
import DOMPurify from "dompurify";
import { renderTemplate } from "@workspace/theme-engine";

/**
 * Renders a sandboxed, markup-only theme template.
 *
 * Defense in depth:
 *  1. The engine's `renderTemplate` is a logic-limited interpreter — no eval,
 *     no network, no fs, bounded steps/loops/output. It produces HTML text.
 *  2. We then run that HTML through DOMPurify before it ever touches the DOM,
 *     so even a future interpreter bug cannot introduce active content.
 *
 * There is no path for author JavaScript to run in the storefront origin.
 */
export function TemplateSlot({
  source,
  context,
}: {
  source: string;
  context?: Record<string, unknown>;
}) {
  const html = useMemo(() => {
    let rendered = "";
    try {
      rendered = renderTemplate(source ?? "", context ?? {});
    } catch {
      rendered = "";
    }
    return DOMPurify.sanitize(rendered, { USE_PROFILES: { html: true } });
  }, [source, context]);

  return <div className="nx-template-slot" dangerouslySetInnerHTML={{ __html: html }} />;
}
